//配置全局访问接口地址
let commonUrl = window.location.protocol + '//api.' + document.domain.match(/[^.]*\.[^.]*$/)[0];//https://dev.usdttrx889.icu/
// let commonUrl = "https://api.699999.me";

let baseUrl = {
    commonUrl
}

export default baseUrl